import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import { injectIntl } from 'react-intl';
import {
  MunicipalitySelector, CustomButton, AutoComplete, Typography
} from '../../components';
import * as actions from '../redux/actions';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    margin: '10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    justifyContent: 'flex-start',
    [theme.breakpoints.down(800)]: {
      alignItems: 'center',
    },
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    height: '100%',
    padding: '20px',
    paddingLeft: 0
  },
  municipality: {
    width: '100%',
    marginBottom: '25px',
    [theme.breakpoints.down(800)]: {
      width: '90%',
      cf: '10px'
    },
  },
  prompt: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginTop: '10px',
    [theme.breakpoints.down(800)]: {
      width: '90%',
      margin: '10px'
    },
  },
  preview: {
    width: '130px',
    position: 'absolute',
    bottom: '20px',
    right: '20px',
    [theme.breakpoints.down(800)]: {
      width: '30%',
      margin: '10px'
    },
  },
  singleCollectionPreviewButton: {
    width: '18%',
    marginRight: '20px',
    [theme.breakpoints.down(800)]: {
      width: '30%',
      marginRight: '0px',
    },
  },
  singleCollection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down(800)]: {
      flexDirection: 'column',
      alignItems: 'center',
      margin: '10px',
    },
  }
}));

const Header = ({
  intl,
  getZoneRequest,
  allZones,
  prompts,
  municipalities,
  getAllScheduleRequest
}) => {
  const classes = useStyles();
  const [district, setDistrict] = useState(municipalities[0]);
  const [zones, setZones] = useState({});

  useEffect(() => {
    if (district !== null) {
      getZoneRequest(district.district_id);
    }
  }, [district]);

  useEffect(() => {
    setDistrict(municipalities[0]);
  }, [municipalities]);

  return (
    <div className={classes.root}>
      <div className={`${classes.panel} ${municipalities && municipalities.length === 1 ? 'pt-0 mt-0' : null}`}>
        {/* left panel */}
        {municipalities && municipalities.length > 1
          && (
            <div className={classes.municipality}>
              <MunicipalitySelector
                hasAllDistrictOption={false}
                className="w-100"
                title={intl.formatMessage({ id: 'GENERAL.MUNICIPALITY' })}
                onChange={(data) => {
                  setDistrict(data);
                  setZones({});
                }}
                value={district}
              />
            </div>
          )}
        {
          prompts
          && !!prompts.length
          && prompts.map((item, id) => (
            <div
              key={item.prompt_id}
              className={classes.prompt}
            >
              <Typography className="mb-2 mt-2" variant="bodySemiBold">
                {`${item.prompt_nm} : `}
              </Typography>

              <AutoComplete
                isDisable={district === null || allZones === []}
                className="w-100"
                disableClearable={false}
                // title={intl.formatMessage({ id: 'SCHEDULE.HEADER.PROMPTS' })}
                optionTitle="zone_nm"
                optionId="zone_id"
                value={zones[id]}
                options={allZones.filter((it) => it.prompt_id === item.prompt_id)}
                onChange={(data) => {
                  if (data && data.zone_id) {
                    setZones({
                      ...zones,
                      [id]: data.zone_id
                    });
                  } else {
                    const temp = { ...zones };
                    delete temp[id];
                    setZones(temp);
                  }
                }}
              />
            </div>
          ))
        }
      </div>

      <CustomButton
        disabled={Object.values(zones).length <= 0}
        variant="contained"
        className={`${classes.preview} ${prompts.length <= 1 ? classes.singleCollectionPreviewButton : null}`}
        label={intl.formatMessage({ id: 'GENERAL.PREVIEW' })}
        onClick={() => getAllScheduleRequest({
          project_id: (district.district_id).split('#$#')[0],
          district_id: (district.district_id).split('#$#')[1],
          zones: Object.values(zones),
        })}
      />
    </div>
  );
};

const mapStateToProps = (store) => ({
  allZones: store.schedule.zones,
  prompts: store.schedule.prompts,
  municipalities: store.common.municipalities,
});

export default injectIntl(connect(mapStateToProps, actions)(Header));
